module.exports = __webpack_public_path__ + "img/bg-3.ebc0cc5c.png";